let startLoading = () => {};
let stopLoading = () => {};

export const setLoadingFunctions = (startFn, stopFn) => {
  startLoading = startFn;
  stopLoading = stopFn;
};

export const showLoader = () => startLoading();
export const hideLoader = () => stopLoading();
